module.exports = __webpack_public_path__ + "img/logo_helinox_big.b00e9a9c.png";